import { render, staticRenderFns } from "./MqData.vue?vue&type=template&id=6499a28b&scoped=true&"
import script from "./MqData.vue?vue&type=script&lang=js&"
export * from "./MqData.vue?vue&type=script&lang=js&"
import style0 from "./MqData.vue?vue&type=style&index=0&id=6499a28b&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6499a28b",
  null
  
)

export default component.exports